import { Validator } from "vee-validate";
import ValidationUtil from "../entity/ValidationUtil";

export default {
  init() {
    // 電話番号の有効性チェック
    Validator.extend("custom_phoneNumber", {
      getMessage: () => "正しい電話番号を入力してください",
      validate: value => ValidationUtil.validateTel_jp(value)
    });

    // 未来日チェック
    Validator.extend("custom_isFutureDate", {
      getMessage: () => "未来日を入力してください",
      validate: value => ValidationUtil.isFutureDate(value)
    });
  }
};
